import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../components/config";
import DashboardLayout from "../components/DashboardLayout/DasboardLayout";
import FileAttachment from "./AttachFile";
import Modal from "react-modal";
// Custom Styles (tailored for white background + #002966 accent)
const customStyles = `
  .neu-card {
    background: #fff;
    border-radius: 1.5rem;
    box-shadow: 0 6px 32px 0 rgba(0,0,0,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.06);
    transition: box-shadow .15s;
    padding: 2rem;
    margin-bottom: 2rem;
  }
  .neu-card:focus-within {
    box-shadow: 0 8px 40px 0 rgba(0,41,102,0.09), 0 2px 8px 0 #00296633;
  }
  .accent {
    color: #002966;
  }
  .accent-bg {
    background: #002966;
    color: #fff;
  }
  .accent-border {
    border-color: #002966 !important;
  }
  .input-accent:focus, .input-accent:active {
    border-color: #002966 !important;
    box-shadow: 0 0 0 2px #00296633;
    outline: none;
  }
  .disabled {
    background: #f7f7f7 !important;
    color: #ccc !important;
    cursor: not-allowed !important;
    pointer-events: none;
  }
  .step-indicator {
    display: flex;
    gap: 1.5rem;
    justify-content: center;
    margin-bottom: 2rem;
  }
  .step {
    position: relative;
    font-weight: 600;
    letter-spacing: .02em;
    color: #b0b0b0;
    transition: color .2s;
  }
  .step.active {
    color: #002966;
  }
  .step:not(:last-child):after {
    content: '';
    display: inline-block;
    margin-left: 1rem;
    margin-right: 1rem;
    width: 24px;
    height: 2px;
    background: #e3e3e3;
    vertical-align: middle;
  }
  .step.active:not(:last-child):after {
    background: #002966;
  }
  .chat-id-pill {
    background: #e9f1fb;
    color: #002966;
    font-weight: 600;
    border-radius: 999px;
    padding: .3em 1em;
    font-size: .93em;
    display: inline-block;
    margin-bottom: 1em;
    letter-spacing: .01em;
    box-shadow: 0 1px 2px 0 #00296622;
  }
     .neu-card {
    background: #fff;
    border-radius: 1.5rem;
    box-shadow: 0 6px 32px 0 rgba(0,0,0,0.06), 0 1.5px 4px 0 rgba(0,0,0,0.06);
    transition: box-shadow .15s;
    padding: 2rem;
    margin-bottom: 2rem;
  }
  .modal {
    background: white;
    padding: 20px;
    border-radius: 10px;
    max-width: 500px;
    margin: auto;
    position: relative; /* Adjusted for positioning */
  }
  .overlay {
    background: rgba(0, 0, 0, 0.7);
    position: fixed; /* Make it fixed */
    top: 0; /* Cover the entire viewport */
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .accent {
    color: #002966;
  }
  .accent-bg {
    background: #002966;
    color: #fff;
  }
  .input-accent:focus, .input-accent:active {
    border-color: #002966 !important;
    box-shadow: 0 0 0 2px #00296633;
    outline: none;
  }
`;

const ChatSupportPage = () => {
  const [chatData, setChatData] = useState({
    customer_id: localStorage.getItem("adminId") || "",
    date_created: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [supportData, setSupportData] = useState({
    customer_id: localStorage.getItem("adminId"),
    customer_name: "",
    phone1: "",
    phone2: "",
    email: "",
    surname: "",
    company: "Xgo",
    product: "Xgo",
    conversation_stage: "assigned",
    person_assigned: "",
    expiry_date_time: "",
    priority_level: "",
    created_at: "",
    estimation_duration: "",
    description: "",
    chat_id: "",
    department: "",
  });

  const [chatId, setChatId] = useState(null);
  const [attendants, setAttendants] = useState([]);
  const [selectedAttendant, setSelectedAttendant] = useState("");
  const [chatLoading, setChatLoading] = useState(false);
  const [ticketLoading, setTicketLoading] = useState(false);
  const [chatSuccess, setChatSuccess] = useState(false);
  const [ticketSuccess, setTicketSuccess] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  useEffect(() => {
    const fetchAttendants = async () => {
      try {
        const response = await axios.get(`${API_URL}/users`);
        setAttendants(response.data);
      } catch (error) {
        setAttendants([]);
      }
    };
    fetchAttendants();
  }, []);

  // Reset ticket form on new chat
  useEffect(() => {
    if (chatId) {
      setSupportData((prev) => ({
        ...prev,
        chat_id: chatId,
        person_assigned: selectedAttendant,
      }));
    }
  }, [chatId, selectedAttendant]);

  const handleChatSubmit = async (e) => {
    e.preventDefault();
    setChatLoading(true);
    setChatSuccess(false);
    setTicketSuccess(false);
    try {
      const response = await axios.post(
        `${API_URL}/clientservicechat`,
        { ...chatData, admin_id: selectedAttendant }
      );
      setChatId(response.data.client_service_chat_id);
      setChatSuccess(true);
    } catch (error) {
      alert("Failed to create chat! Please try again.");
    }
    setChatLoading(false);
  };

  const handleSupportSubmit = async (e) => {
    e.preventDefault();
    setTicketLoading(true);
    setTicketSuccess(false);
    try {
      const response = await axios.post(`${API_URL}/tickets`, {
        ...supportData,
        chat_id: chatId,
        person_assigned: selectedAttendant,
      });
      setTicketSuccess(true);
    } catch (error) {
      alert("Failed to create ticket! Please try again.");
    }
    setTicketLoading(false);
  };

  return (
    <DashboardLayout>
      <style>{customStyles}</style>
      <div className="min-h-screen bg-white px-2 md:px-12 py-10">
        {/* Step Indicator */}
        <div className="step-indicator" aria-label="progress">
          <div className={`step ${!chatId ? "active" : ""}`}>
            1. Create Chat
          </div>
          <div className={`step ${chatId ? "active" : ""}`}>
            2. Create Ticket
          </div>
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          {/* Create Chat */}
          <section className="neu-card flex-1" aria-label="Create Chat">
            <h1 className="text-2xl font-bold accent mb-2">Create Chat</h1>
            <form onSubmit={handleChatSubmit} autoComplete="off">
              <label
                className="block font-medium mb-1 text-sm accent"
                htmlFor="customer_id"
              >
                Customer ID
              </label>
              <input
                id="customer_id"
                type="text"
                value={chatData.customer_id}
                readOnly
                className="input-accent disabled block w-full mt-1 mb-3 p-2 rounded-md border accent-border bg-gray-100"
              />
              <label
                className="block font-medium mb-1 text-sm accent"
                htmlFor="date_created"
              >
                Date Created
              </label>
              <input
                id="date_created"
                type="datetime-local"
                value={chatData.date_created}
                onChange={(e) =>
                  setChatData({ ...chatData, date_created: e.target.value })
                }
                required
                className="input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border"
              />
              <label
                className="block font-medium mb-1 text-sm accent"
                htmlFor="assign_to"
              >
                Assign To
              </label>
              <select
                id="assign_to"
                value={selectedAttendant}
                onChange={(e) => setSelectedAttendant(e.target.value)}
                className="input-accent block w-full mt-1 mb-4 p-2 rounded-md border accent-border"
                required
                aria-required="true"
              >
                <option value="">Select Attendant</option>
                {attendants.map((attendant) => (
                  <option key={attendant.userid} value={attendant.userid}>
                    {attendant.username} ({attendant.userid})
                  </option>
                ))}
              </select>
              <button
                type="submit"
                className={`accent-bg w-full py-2 rounded-lg font-semibold shadow-md transition-all duration-150 hover:scale-[1.025] hover:shadow-lg ${
                  chatLoading ? "opacity-60 pointer-events-none" : ""
                }`}
                disabled={chatLoading}
              >
                {chatLoading ? "Creating..." : "Create Chat"}
              </button>
              {chatSuccess && (
                <div className="mt-3 text-green-600 font-medium text-sm animate-fade">
                  Chat created! Proceed to ticket.
                </div>
              )}
            </form>
            {chatSuccess && (
              <div className="mt-3 text-green-600 font-medium text-sm animate-fade">
                <button onClick={toggleModal} className="accent-bg mt-4">
                  Attach File
                </button>
              </div>
            )}
          </section>
          {/* Ticket (Conversation Support) */}
          <section className="neu-card flex-1" aria-label="Create Ticket">
            <h1 className="text-2xl font-bold accent mb-2">Create Ticket</h1>
            <form onSubmit={handleSupportSubmit} autoComplete="off">
              {/* Show Chat ID */}
              <div className="chat-id-pill mb-4" aria-live="polite">
                {chatId ? (
                  <>
                    <span className="accent font-bold">Chat ID:</span> {chatId}
                  </>
                ) : (
                  <span className="text-gray-400">
                    Please create a chat first
                  </span>
                )}
              </div>
              {/* All form fields are disabled until chatId is present */}
              <fieldset disabled={!chatId} aria-disabled={!chatId}>
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="ticket_customer_id"
                >
                  Customer ID
                </label>
                <input
                  id="ticket_customer_id"
                  type="text"
                  value={supportData.customer_id}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      customer_id: e.target.value,
                    })
                  }
                  required
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                  aria-required="true"
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="customer_name"
                >
                  Customer Name
                </label>
                <input
                  id="customer_name"
                  type="text"
                  value={supportData.customer_name}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      customer_name: e.target.value,
                    })
                  }
                  required
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                  aria-required="true"
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="phone1"
                >
                  Phone 1
                </label>
                <input
                  id="phone1"
                  type="text"
                  value={supportData.phone1}
                  onChange={(e) =>
                    setSupportData({ ...supportData, phone1: e.target.value })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="phone2"
                >
                  Phone 2
                </label>
                <input
                  id="phone2"
                  type="text"
                  value={supportData.phone2}
                  onChange={(e) =>
                    setSupportData({ ...supportData, phone2: e.target.value })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="email"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={supportData.email}
                  onChange={(e) =>
                    setSupportData({ ...supportData, email: e.target.value })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="surname"
                >
                  Surname
                </label>
                <input
                  id="surname"
                  type="text"
                  value={supportData.surname}
                  onChange={(e) =>
                    setSupportData({ ...supportData, surname: e.target.value })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="expiry_date_time"
                >
                  Expiry Date Time
                </label>
                <input
                  id="expiry_date_time"
                  type="datetime-local"
                  value={supportData.expiry_date_time}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      expiry_date_time: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="priority_level"
                >
                  Priority Level (1-3)
                </label>
                <input
                  id="priority_level"
                  type="number"
                  min="1"
                  max="3"
                  value={supportData.priority_level}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      priority_level: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="created_at"
                >
                  Created At
                </label>
                <input
                  id="created_at"
                  type="datetime-local"
                  value={supportData.created_at}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      created_at: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="estimation_duration"
                >
                  Estimation Duration
                </label>
                <input
                  id="estimation_duration"
                  type="text"
                  value={supportData.estimation_duration}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      estimation_duration: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="description"
                >
                  Description
                </label>
                <textarea
                  id="description"
                  rows="2"
                  value={supportData.description}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      description: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <label
                  className="block font-medium mb-1 text-sm accent"
                  htmlFor="department"
                >
                  Department
                </label>
                <input
                  id="department"
                  type="text"
                  value={supportData.department}
                  onChange={(e) =>
                    setSupportData({
                      ...supportData,
                      department: e.target.value,
                    })
                  }
                  className={`input-accent block w-full mt-1 mb-3 p-2 rounded-md border accent-border ${
                    !chatId ? "disabled" : ""
                  }`}
                />
                <button
                  type="submit"
                  className={`accent-bg w-full py-2 rounded-lg font-semibold shadow-md transition-all duration-150 hover:scale-[1.025] hover:shadow-lg mt-2 ${
                    ticketLoading ? "opacity-60 pointer-events-none" : ""
                  }`}
                  disabled={ticketLoading || !chatId}
                >
                  {ticketLoading ? "Creating..." : "Create Ticket"}
                </button>
                {ticketSuccess && (
                  <div className="mt-3 text-green-600 font-medium text-sm animate-fade">
                    Ticket created! 🎉
                  </div>
                )}
              </fieldset>
            </form>
          </section>
        </div>
        {/* Modal for File Attachment */}
        <Modal
          isOpen={isModalOpen}
          onRequestClose={toggleModal}
          contentLabel="Attach File Modal"
          className="modal"
          overlayClassName="overlay"
        >
          <h2 className="text-2xl font-bold">Attach a File</h2>
          <FileAttachment
            userId={localStorage.getItem("adminId")}
            reciever={selectedAttendant}
            chatId={chatId} // Replace with the actual username
            onMessageSend={() => {
              // Handle message sending after file attachment
              toggleModal();
            }}
          />
          <button onClick={toggleModal} className="mt-4 accent-bg">
            Close
          </button>
        </Modal>
      </div>
    </DashboardLayout>
  );
};

export default ChatSupportPage;
